import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { ArrowRight, Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSmileCraftWay() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const images = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/clinic_architecture_detail_01.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/clinic_architecture_detail_02.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/clinic_architecture_detail_03.png"];
  return <section data-section-id="31603" id="the-bodywerks-philosophy" ref={sectionRef} className="relative w-full py-24 overflow-hidden dark bg-background text-foreground">
      <div className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-12 lg:gap-0">
          
          {}
          <div className="lg:col-span-7 relative z-10 w-full">
            <Carousel opts={{
            loop: true,
            align: "start"
          }} className="w-full shadow-2xl rounded-2xl overflow-hidden">
              <CarouselContent>
                {images.map((src, index) => <CarouselItem key={index} className="basis-full">
                    <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
                      <img src={src} alt={`Bodywerks Clinic Interior Detail ${index + 1}`} className="object-cover w-full h-full transition-transform duration-700 hover:scale-105" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              
              {}
              <div className="absolute bottom-6 right-6 flex gap-2">
                <CarouselPrevious className="static translate-y-0 translate-x-0 bg-background/80 hover:bg-background text-foreground border-none shadow-lg backdrop-blur-sm" />
                <CarouselNext className="static translate-y-0 translate-x-0 bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-lg" />
              </div>
            </Carousel>
            
            {}
            <div className="absolute -top-10 -left-10 w-32 h-32 bg-primary/20 rounded-full blur-3xl -z-10" />
          </div>

          {}
          {}
          <div className="lg:col-span-6 lg:-ml-24 relative z-20">
            <div className="bg-card/95 backdrop-blur-md p-8 md:p-12 rounded-2xl shadow-2xl border border-border/50">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-12 bg-primary"></span>
                <span className="text-primary font-sans font-medium tracking-wider uppercase text-sm">Our Philosophy</span>
              </div>
              
              <h2 className="text-3xl md:text-5xl font-serif text-foreground mb-6 leading-tight">
                The Bodywerks Ethos: Precision Care in the Heart of Cyprus
              </h2>
              
              <div className="space-y-6 text-muted-foreground font-sans text-lg leading-[1.8]">
                <p>
                  At Bodywerks, we redefine the clinical experience by blending specialized chiropractic and acupuncture expertise with the welcoming spirit of Cyprus. Our Limassol and Nicosia clinics are designed as sanctuaries of healing, where international medical standards meet Mediterranean warmth.
                </p>
                <p>
                  Whether you are a local resident or part of our vibrant expat community, our multi-disciplinary team is committed to restoring your body's natural rhythm. From elite chiropractic adjustments to restorative acupuncture, every journey is tailored to your unique lifestyle and goals.
                </p>
              </div>

              <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8 border-t border-border pt-8">
                <div className="flex flex-col gap-2">
                  <Quote className="size-8 text-primary/30 mb-1" />
                  <p className="font-serif italic text-2xl text-foreground">Dr. Zano Tyrannis<br /></p>
                  <span className="text-sm text-muted-foreground uppercase tracking-widest font-sans">Lead Practitioner</span>
                </div>
                
                <Button asChild size="lg" className="rounded-full px-8 shadow-xl shadow-primary/10 bg-primary text-primary-foreground hover:bg-primary/90">
                  <Link to="/OurStoryPage">
                    Our Story <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}